<template>
  <div
    class="uploader"
    @drop.prevent="handleDrop" 
    @dragover.prevent="handleDragover"
  >
    <template v-if="loading">
      <slot name="loading">
        <p>Carregando ...</p>
      </slot>
    </template>
    <template v-else>
      <slot name="uploaderActions" :handles="{buscarBackend,handleSelecionarButtonClick}">
        <p>
          Arraste e solte aqui
        </p>
        <p>
          Ou <button @click="handleSelecionarButtonClick">Selecione uma foto</button>
        </p>
          <p>
            Ou informe o link aqui: 
            <input type="text" ref="link">
            <button @click="handleBuscarButtonClick">Buscar</button>
          </p>
      </slot>
    </template>
    <input
      type="file" 
      accept="image/*" 
      ref="file"
      @change="handleFileInputChange"
    >
    <span class="error--text">{{error}}</span>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ImageUploader',
  data() {
    return {
      loading: false,
      error:null
    };
  },
  mounted() {
    window.addEventListener('paste', this.pasteListener);
  },
  beforeDestroy() {
    window.removeEventListener('paste', this.pasteListener);
  },
  methods: {
    pasteListener(event) {
      if (event.clipboardData.files.length > 0) {
        this.setImage(event.clipboardData.files[0]);
        event.preventDefault();
      }
    },
    setImage(file) {
      this.emitSelectingImage();
      if (file.type.indexOf('image/') === -1) {
        this.error = 'O arquivo selecionado não é uma imagem'
        return;
      }
      if (typeof FileReader === 'function') {
        const reader = new FileReader();
        reader.onload = event => this.emitImageLoaded(event.target.result);
        reader.readAsDataURL(file);
      } else {
        this.error = 'FileReader API não suportada'
      }
    },
    async buscarBackend(link) {
      this.emitSelectingImage();
      try {
        this.loading = true;
        const response = await axios.post('/baixar-foto', { link });
        this.emitImageLoaded(response.data.src);
      }
      catch (error) {
        console.log(error);
        this.error = error.response.data.message
      }
      finally {
        this.loading = false;
      }
    },
    // events
    handleDragover(event) {
      event.dataTransfer.dropEffect = 'copy';
    },
    async handleDrop(event) {
      const files = event.dataTransfer.files;
      if (files.length > 0) {
        this.setImage(files[0]);
        return;
      }
      const link = event.dataTransfer.getData('text');
      if(!link || link.startsWith('file')){
        this.error = "Não conseguimos carregar a imagem. Tente novamente."
        return
      }
      await this.buscarBackend(link);
    },
    handleFileInputChange(event) {
      const file = event.target.files[0];
      this.setImage(file);
    },
    handleSelecionarButtonClick() {
      this.triggerFileInputClick();
    },
    triggerFileInputClick() {
      this.$refs.file.click();
    },
    async handleBuscarButtonClick() {
      const link = this.$refs.link.value;
      this.$refs.link.value = '';
      if (link === '') {
        return;
      }
      await this.buscarBackend(link);
    },
    emitImageLoaded(data) {
      this.$emit('image-loaded', data);
    },
    emitSelectingImage() {
      this.$emit('selecting-image');
    }
  }
}
</script>

<style scoped>
input[type='file'] {
  display: none;
}
</style>
